"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const executeIfNotProduction = (func) => {
    if (process.env.NODE_ENV !== 'production') {
        func();
    }
};
const logError = (message) => {
    executeIfNotProduction(() => {
        console.error(`Error: ${message}`); // tslint:disable-line
    });
};
exports.logError = logError;
const logWarning = (message) => {
    executeIfNotProduction(() => {
        console.warn(`Warning: ${message}`); // tslint:disable-line
    });
};
exports.logWarning = logWarning;
//# sourceMappingURL=log.js.map